import {
  agListNameCellRenderer,
  agListReferencesCellRenderer,
  agListPricesCellRenderer,
  agListQuantityCellRenderer,
  favoriteCellRenderer,
  departmentCellRenderer,
  isNewRenderer,
  agListTabletRenderer,
  agListMobileRenderer,
  agListImageCellRenderer,
} from 'components/Aggrid/cellRenderers.jsx';
import { promoListTimerCellRenderer } from 'pages/Promotion/cellRenderers';

const columnDefs = [
  {
    colId: 'department',
    headerName: 'Département',
    field: 'type',
    floatingFilter: true,
    hide: true,
    cellRenderer: departmentCellRenderer,
    filterParams: {
      cellRenderer: departmentCellRenderer,
    },
  },
  {
    colId: 'zone',
    headerName: 'Secteur',
    field: 'zone_name',
    floatingFilter: true,
    hide: true,
  },
  {
    colId: 'aisle',
    headerName: 'Rayon',
    field: 'aisle_name',
    floatingFilter: true,
    hide: true,
  },
  {
    colId: 'category',
    headerName: 'Famille',
    field: 'category_name',
    floatingFilter: true,
    hide: true,
  },
  {
    colId: 'sub_category',
    headerName: 'Sous-Famille',
    field: 'subcategory_name',
    floatingFilter: true,
    hide: true,
  },
  {
    colId: 'top_sales_position',
    headerName: 'Postion top vente',
    field: 'topPosition',
    floatingFilter: true,
    hide: true,
  },
  {
    headerName: 'Nouveauté',
    field: 'is_new',
    floatingFilter: true,
    cellRenderer: isNewRenderer,
    filterParams: {
      cellRenderer: isNewRenderer,
    },
    hide: true,
  },
  {
    field: 'name',
    floatingFilter: true,
    hide: true,
  },
  {
    field: 'reference',
    floatingFilter: true,
    hide: true,
  },
  {
    headerName: 'Libellé',
    floatingFilter: true,
    hide: true,
  },
  {
    headerName: 'Marque',
    floatingFilter: true,
    hide: true,
  },
  {
    field: 'ean13',
    floatingFilter: true,
    hide: true,
  },
  {
    colId: 'imageCell',
    field: 'product',
    width: 100,
    cellRendererFramework: agListImageCellRenderer,
    suppressSizeToFit: true,
    autoHeight: true,
    wrapText: true,
  },
  {
    colId: 'agListNameCell',
    field: 'product',
    cellRendererFramework: agListNameCellRenderer,
  },
  {
    colId: 'agListPriceCell',
    field: 'product',
    cellRendererFramework: agListPricesCellRenderer,
  },
  {
    colId: 'timerCell',
    field: 'product',
    cellRendererFramework: promoListTimerCellRenderer,
  },
  {
    colId: 'tabletCell',
    field: 'product',
    cellRendererFramework: agListTabletRenderer,
    suppressFiltersToolPanel: true,
    hide: true,
  },
  {
    colId: 'mobileCell',
    field: 'product',
    cellRendererFramework: agListMobileRenderer,
    suppressFiltersToolPanel: true,
    hide: true,
    autoHeight: true,
    wrapText: true,
  },
  {
    colId: 'agListQuantityCell',
    field: 'product',
    cellRendererFramework: agListQuantityCellRenderer,
    suppressFiltersToolPanel: true,
    suppressSizeToFit: true,
  },
  {
    colId: 'favoriteCell',
    field: 'product',
    cellRendererFramework: favoriteCellRenderer,
    width: 50,
    suppressSizeToFit: true,
    cellStyle: {
      'justify-content': 'flex-end',
      'align-items': 'flex-start',
      padding: '12px 20px 0 0',
      'font-size': '20px',
    },
  },
];

export default columnDefs;
